<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<!--  Баблы внутренних табов  -->
<div class="bubble-container head">
    <button [class.selected]="tab === 0"
            (click)="tab = 0"
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.MAIN' | translate }}
    </button>
    <button [class.selected]="tab === 1"
            (click)="tab = 1"
            disabled
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.STATISTICS' | translate }}
    </button>
    <button [class.selected]="tab === 2"
            (click)="tab = 2"
            disabled
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.HISTORY' | translate }}
    </button>
</div>

@if (allBoards || allGroups) {
    <app-task-dashboards-v2
            [boards]="allBoards"
            [allGroups]="allGroups"
    ></app-task-dashboards-v2>
} @else {
    <ng-container *ngTemplateOutlet="loading"></ng-container>
}
